import { render, staticRenderFns } from "./RoleColorPicker.vue?vue&type=template&id=0fb51788&"
import script from "./RoleColorPicker.vue?vue&type=script&lang=js&"
export * from "./RoleColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./RoleColorPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoleColorPicker.vue"
export default component.exports